class DeliveryTimer {
  constructor() {
    this.timerInterval = null;
    if (document.querySelector('.delivery-timer')) {
      this.initTimer();
    }
  }

  initTimer() {
    // Clear any existing interval to prevent duplicates
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.updateDeliveryTimer();
    this.timerInterval = setInterval(() => this.updateDeliveryTimer(), 1000);
  }

  updateDeliveryTimer() {
    const wrapper = document.querySelector('.delivery-timer');
    const timerElement = document.querySelector('.timer');

    // Safety check - if elements don't exist, clean up and exit
    if (!wrapper || !timerElement) {
      this.cleanup();
      return;
    }

    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setUTCHours(12, 0, 0, 0);

    if (now.getUTCHours() >= 12) {
      targetTime.setUTCDate(targetTime.getUTCDate() + 1);
      wrapper.classList.remove('before_noon');
      wrapper.classList.add('after_noon');
    } else {
      wrapper.classList.remove('after_noon');
      wrapper.classList.add('before_noon');
    }

    const diff = targetTime.getTime() - now.getTime();

    const hours = this.formatTimeUnit(Math.floor(diff / (1000 * 60 * 60)));
    const minutes = this.formatTimeUnit(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = this.formatTimeUnit(Math.floor((diff % (1000 * 60)) / 1000));

    timerElement.innerHTML = `${hours} : ${minutes} : ${seconds}`;
  }

  formatTimeUnit(unit) {
    return unit < 10 ? '0' + unit : unit;
  }

  cleanup() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }
}

class MainOfferWu18233 extends HTMLElement {
  constructor() {
    super();
    this.inputs = null;
    this.submitButton = null;
    this.subscriptionToggle = null;
    this.giftRows = null;
    this.hasSubscriptionToggle = false;
    this.abortController = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  init() {
    // Clean up any existing event listeners before re-initializing
    this.cleanup();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    // Cache DOM elements
    this.inputs = this.querySelectorAll('input[name="offer-quantity"]');
    this.submitButton = this.querySelector('#offer-submit-button');
    this.subscriptionToggle = document.querySelector('#subscription-toggle');
    this.giftRows = this.querySelectorAll('.offer-gifts_row');

    // Check if subscription toggle exists (from data attribute set by Liquid)
    this.hasSubscriptionToggle = this.dataset.hasSubscriptionToggle === 'true';

    // Set offer_version from parent element to all inputs
    const offerVersion = this.dataset.offerVersion || '';
    this.inputs.forEach((input) => {
      if (offerVersion) {
        input.dataset.offerVersion = offerVersion;
      }
    });

    // Restore saved selection from sessionStorage
    this.restoreSelection();

    // Setup event listeners
    this.setupEventListeners(signal);

    // Initial updates
    this.updatePrices();
    this.updateGiftDisplay();
    this.updateOfferVisibilityByVariantMode();

    // Reset button to initial state
    this.resetButton();
  }

  setupEventListeners(signal) {
    // Update prices and gifts on input change
    this.inputs.forEach((input) => {
      input.addEventListener(
        'change',
        () => {
          this.updatePrices();
          this.updateGiftDisplay();
        },
        { signal }
      );
    });

    // Update prices when subscription toggle changes
    if (this.subscriptionToggle) {
      this.subscriptionToggle.addEventListener(
        'change',
        () => {
          this.updatePrices();
          this.updateOfferVisibilityByVariantMode();
          // Save subscription state to sessionStorage
          sessionStorage.setItem('main-offer-wu-18233-subscription', this.subscriptionToggle.checked);
        },
        { signal }
      );
    }

    // Handle submit button click
    if (this.submitButton) {
      this.submitButton.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          this.handleCheckout();
        },
        { signal }
      );
    }
  }

  /**
   * Update offer visibility based on variant_mode and subscription toggle state
   * - has_sub_only: Show only when subscription toggle is ON (or when no toggle exists)
   * - has_onetime_only: Show only when subscription toggle is OFF (or when no toggle exists)
   * - has_both or has_none: Always visible (toggle just changes which variant is used)
   */
  updateOfferVisibilityByVariantMode() {
    const isSubscription = this.subscriptionToggle ? this.subscriptionToggle.checked : true;
    const offerWrappers = document.querySelectorAll('.offer-quantity-wrapper, .offer-onetime-cta-wrapper');

    let hasCheckedOffer = false;
    let firstVisibleOffer = null;

    offerWrappers.forEach((wrapper) => {
      const variantMode = wrapper.dataset.variantMode;
      const input = wrapper.querySelector('input[type="radio"]');

      // Check if hidden by dogsize filtering
      const isDogSizeHidden =
        wrapper.classList.contains('offer-quantity-wrapper--hidden-dogsize') ||
        wrapper.classList.contains('offer-quantity-wrapper--hidden');

      // Determine if this offer should be visible based on variant mode
      let shouldBeVisibleByVariantMode = true;

      if (this.hasSubscriptionToggle) {
        // Subscription toggle exists - hide/show based on mode
        if (variantMode === 'has_sub_only') {
          shouldBeVisibleByVariantMode = isSubscription;
        } else if (variantMode === 'has_onetime_only') {
          shouldBeVisibleByVariantMode = !isSubscription;
        }
        // has_both and has_none are always visible
      }
      // If no subscription toggle exists, all offers are visible (they act as their own toggles)

      // Apply variant mode visibility class
      if (shouldBeVisibleByVariantMode) {
        wrapper.classList.remove('offer-quantity-wrapper--hidden-variant-mode');
      } else {
        wrapper.classList.add('offer-quantity-wrapper--hidden-variant-mode');
        // Uncheck if being hidden
        if (input && input.checked) {
          input.checked = false;
        }
      }

      // Determine final visibility (must pass both filters)
      const isVisible = shouldBeVisibleByVariantMode && !isDogSizeHidden;

      if (isVisible) {
        wrapper.style.display = '';
        if (!firstVisibleOffer) {
          firstVisibleOffer = wrapper;
        }
        if (input && input.checked) {
          hasCheckedOffer = true;
        }
      } else {
        wrapper.style.display = 'none';
      }
    });

    // If no offer is checked, select the first visible one
    if (!hasCheckedOffer && firstVisibleOffer) {
      const input = firstVisibleOffer.querySelector('input[type="radio"]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  getActiveInput() {
    return this.querySelector('input[name="offer-quantity"]:checked');
  }

  updatePrices() {
    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    const priceDefault = activeInput.dataset.priceDefault;
    const subPriceDiscounted = activeInput.dataset.subPriceDiscounted;
    const otpPriceDiscounted = activeInput.dataset.onetimePriceDiscounted;
    const subDiscountPercent = activeInput.dataset.subDiscountPercent;
    const otpDiscountPercent = activeInput.dataset.onetimeDiscountPercent;
    const variantMode = activeInput.dataset.variantMode || 'has_none';

    // Determine if we should show subscription or one-time prices based on variant mode
    let isSubscription;

    if (variantMode === 'has_sub_only') {
      // Block only has subscription ID - always show subscription prices
      isSubscription = true;
    } else if (variantMode === 'has_onetime_only') {
      // Block only has one-time ID - always show one-time prices
      isSubscription = false;
    } else {
      // has_both or has_none: use toggle state (default to subscription if no toggle)
      isSubscription = this.subscriptionToggle ? this.subscriptionToggle.checked : true;
    }

    const currentDiscountPercent = isSubscription ? subDiscountPercent : otpDiscountPercent;

    // Update button prices based on subscription state
    const priceDiscountedEl = this.querySelector('.js--price-discounted');
    const priceDefaultEl = this.querySelector('.js--price-default');
    const priceDefaultWrapper = this.querySelector('.js--price-default-wrapper');

    if (priceDiscountedEl) {
      priceDiscountedEl.textContent = isSubscription ? subPriceDiscounted : otpPriceDiscounted;
    }

    // Show/hide strikethrough price and separator based on discount
    if (priceDefaultEl && priceDefaultWrapper) {
      if (currentDiscountPercent && parseFloat(currentDiscountPercent) > 0) {
        priceDefaultEl.textContent = priceDefault;
        priceDefaultWrapper.style.display = '';
      } else {
        priceDefaultWrapper.style.display = 'none';
      }
    }

    // Update all discount badges based on subscription state (pass variantMode for per-block handling)
    this.updateDiscountBadges(isSubscription);
  }

  updateDiscountBadges(isSubscription) {
    // Get all quantity inputs
    const quantityInputs = this.querySelectorAll('input[name="offer-quantity"]');

    quantityInputs.forEach((input) => {
      const subPercent = input.dataset.subDiscountPercent;
      const otpPercent = input.dataset.onetimeDiscountPercent;
      const subPriceDiscounted = input.dataset.subPriceDiscounted;
      const otpPriceDiscounted = input.dataset.onetimePriceDiscounted;
      const intervalDays = input.dataset.intervalDays;
      const variantMode = input.dataset.variantMode || 'has_none';
      const includeGiftsPrices = input.dataset.includeGiftsPrices === 'true';
      const defaultPriceValue = input.dataset.priceDefault;

      // Determine which discount/price to show based on variant mode
      let discountToShow, priceToShow;

      if (variantMode === 'has_sub_only') {
        // Always show subscription values
        discountToShow = subPercent;
        priceToShow = subPriceDiscounted;
      } else if (variantMode === 'has_onetime_only') {
        // Always show one-time values
        discountToShow = otpPercent;
        priceToShow = otpPriceDiscounted;
      } else {
        // has_both or has_none: toggle based on subscription state
        discountToShow = isSubscription ? subPercent : otpPercent;
        priceToShow = isSubscription ? subPriceDiscounted : otpPriceDiscounted;
      }

      // Recalculate discount percentage when gift prices are included
      if (includeGiftsPrices && defaultPriceValue && priceToShow) {
        const defaultPriceCents = parseFloat(defaultPriceValue.replace(/[^0-9.]/g, '')) * 100;
        const discountedPriceCents = parseFloat(priceToShow.replace(/[^0-9.]/g, '')) * 100;
        if (defaultPriceCents > 0) {
          discountToShow = parseFloat(((defaultPriceCents - discountedPriceCents) / defaultPriceCents * 100).toFixed(1));
        }
      }

      // Find the corresponding label
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        // Update discount badge - hide if discount is 0
        const badgeWrapper = label.querySelector('.offer-block__center');
        const badge = label.querySelector('.offer-block__badge-relative');

        if (badge) {
          if (discountToShow && discountToShow !== '0' && parseFloat(discountToShow) > 0) {
            badge.textContent = `Save ${discountToShow}%`;
            if (badgeWrapper) {
              badgeWrapper.style.display = '';
            }
          } else {
            // Hide badge wrapper when discount is 0
            if (badgeWrapper) {
              badgeWrapper.style.display = 'none';
            }
          }
        }

        // Calculate and update price per day
        const pricePerDay = label.querySelector('.offer-block__price-per-day');
        if (pricePerDay && priceToShow && intervalDays) {
          const pricePerDayValue = this.calculatePricePerDay(priceToShow, intervalDays);
          pricePerDay.textContent = `${pricePerDayValue}/day`;
        }

        // Update bottom prices if they exist
        this.updateBlockBottomPrices(label, input, isSubscription, variantMode);

        // Update custom titles and secondary text based on subscription state and variant mode
        this.updateBlockContent(label, isSubscription, variantMode);
      }
    });
  }

  /**
   * Update the bottom prices in offer blocks (when show_prices is enabled)
   */
  updateBlockBottomPrices(label, input, isSubscription, variantMode) {
    const priceDefault = input.dataset.priceDefault;
    const subPriceDiscounted = input.dataset.subPriceDiscounted;
    const otpPriceDiscounted = input.dataset.onetimePriceDiscounted;
    const subPercent = parseFloat(input.dataset.subDiscountPercent) || 0;
    const otpPercent = parseFloat(input.dataset.onetimeDiscountPercent) || 0;

    // Update subscription bottom prices
    const subBottomText = label.querySelector('.offer-block__bottom-subscription-text');
    if (subBottomText) {
      const subPriceEl = subBottomText.querySelector('.offer-block__price-discounted');
      const subDefaultWrapper = subBottomText.querySelector('.offer-block__price-default-wrapper');
      const subDefaultEl = subBottomText.querySelector('.offer-block__price-default');

      if (subPriceEl) {
        subPriceEl.textContent = subPriceDiscounted;
      }
      if (subDefaultWrapper && subDefaultEl) {
        if (subPercent > 0) {
          subDefaultEl.textContent = priceDefault;
          subDefaultWrapper.style.display = '';
        } else {
          subDefaultWrapper.style.display = 'none';
        }
      }
    }

    // Update one-time bottom prices
    const otpBottomText = label.querySelector('.offer-block__bottom-onetime-text');
    if (otpBottomText) {
      const otpPriceEl = otpBottomText.querySelector('.offer-block__price-discounted');
      const otpDefaultWrapper = otpBottomText.querySelector('.offer-block__price-default-wrapper');
      const otpDefaultEl = otpBottomText.querySelector('.offer-block__price-default');

      if (otpPriceEl) {
        otpPriceEl.textContent = otpPriceDiscounted;
      }
      if (otpDefaultWrapper && otpDefaultEl) {
        if (otpPercent > 0) {
          otpDefaultEl.textContent = priceDefault;
          otpDefaultWrapper.style.display = '';
        } else {
          otpDefaultWrapper.style.display = 'none';
        }
      }
    }
  }

  /**
   * Update block titles and secondary text based on subscription state and variant mode
   * - has_sub_only or has_onetime_only: Content is static (set by Liquid, no toggling)
   * - has_both or has_none: Toggle content based on subscription state
   */
  updateBlockContent(label, isSubscription, variantMode) {
    // Skip content toggling for sub-only or onetime-only blocks
    // Their content is permanently set by Liquid
    if (variantMode === 'has_sub_only' || variantMode === 'has_onetime_only') {
      return;
    }

    // For has_both or has_none: toggle content based on subscription state
    const titleSub = label.querySelector('.offer-block__title-subscription');
    const titleOnetime = label.querySelector('.offer-block__title-onetime');
    const titleDefault = label.querySelector('.offer-block__title-default');
    const secondarySub = label.querySelector('.offer-block__bottom-subscription-text');
    const secondaryOnetime = label.querySelector('.offer-block__bottom-onetime-text');

    // Update titles
    if (titleSub && titleOnetime) {
      titleSub.style.display = isSubscription ? 'block' : 'none';
      titleOnetime.style.display = isSubscription ? 'none' : 'block';
      if (titleDefault) {
        titleDefault.style.display = 'none';
      }
    } else if (titleSub) {
      titleSub.style.display = isSubscription ? 'block' : 'none';
      if (titleDefault) {
        titleDefault.style.display = isSubscription ? 'none' : 'inline';
      }
    } else if (titleOnetime) {
      titleOnetime.style.display = isSubscription ? 'none' : 'block';
      if (titleDefault) {
        titleDefault.style.display = isSubscription ? 'inline' : 'none';
      }
    } else if (titleDefault) {
      titleDefault.style.display = 'inline';
    }

    // Update secondary text
    if (secondarySub) {
      secondarySub.style.display = isSubscription ? '' : 'none';
    }
    if (secondaryOnetime) {
      secondaryOnetime.style.display = isSubscription ? 'none' : '';
    }
  }

  calculatePricePerDay(priceString, intervalDays) {
    // Remove $ and any other non-numeric characters except decimal point
    const priceValue = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    const days = parseInt(intervalDays);

    if (isNaN(priceValue) || isNaN(days) || days === 0) {
      return '$0.00';
    }

    const perDay = priceValue / days;
    return `$${perDay.toFixed(2)}`;
  }

  updateGiftDisplay() {
    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    const quantity = activeInput.value;

    // Hide all gift rows
    this.giftRows.forEach((row) => {
      row.style.display = 'none';
    });

    // Show only the active quantity's gift row
    const activeRow = this.querySelector(`.offer-gifts-row-${quantity}`);
    if (activeRow) {
      activeRow.style.display = 'flex';
    }
  }

  saveSelection() {
    const activeInput = this.getActiveInput();
    if (activeInput && activeInput.id) {
      sessionStorage.setItem('main-offer-wu-18233-selected', activeInput.id);
    }
  }

  restoreSelection() {
    const savedId = sessionStorage.getItem('main-offer-wu-18233-selected');
    if (savedId) {
      const savedInput = this.querySelector(`#${savedId}`);
      if (savedInput) {
        savedInput.checked = true;
        // Trigger change event to update prices and gifts
        savedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Restore subscription toggle state (default to checked if not saved)
    const savedSubscriptionState = sessionStorage.getItem('main-offer-wu-18233-subscription');
    if (this.subscriptionToggle) {
      if (savedSubscriptionState !== null) {
        this.subscriptionToggle.checked = savedSubscriptionState === 'true';
      } else {
        this.subscriptionToggle.checked = true; // Default to subscription enabled
      }
    }
  }

  resetButton() {
    // Reset submit button: enabled, text visible, spinner hidden
    if (this.submitButton) {
      this.submitButton.disabled = false;
      const spinner = this.submitButton.querySelector('.loading__spinner');
      const buttonText = this.submitButton.querySelector('.picker-submit_btn-text');
      if (spinner) {
        spinner.classList.add('hidden');
      }
      if (buttonText) {
        buttonText.classList.remove('hidden');
      }
    }
  }

  async clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.ok;
    } catch (error) {
      console.error('Error clearing cart:', error);
      return false;
    }
  }

  async addToCart(items, attributes = {}) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items, attributes }),
      });
      return response.ok;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return false;
    }
  }

  async processCheckout(options) {
    const { button, variantIdToUse, sellingPlanId = null, discountPercent, hideButtonText = false } = options;

    const activeInput = this.getActiveInput();
    if (!activeInput) return;

    // Use provided variant ID or fall back to dogsize variant
    const variantId = variantIdToUse || activeInput.dataset.variantId;
    const giftVariantIds = activeInput.dataset.giftVariantIds;
    const giftCode = activeInput.dataset.giftCode;
    const quantity = activeInput.value;
    const offerVersion = activeInput.dataset.offerVersion;
    const variantTitle = activeInput.dataset.variantTitle;

    // Get UI elements
    const spinner = button.querySelector('.loading__spinner');
    const buttonText = button.querySelector('.picker-submit_btn-text');

    // Save selection to sessionStorage
    this.saveSelection();

    // Disable button and show loading state
    button.disabled = true;
    if (spinner) spinner.classList.remove('hidden');
    if (hideButtonText && buttonText) buttonText.classList.add('hidden');

    // Clear cart
    await this.clearCart();

    // Prepare main item
    const mainItem = {
      id: variantId,
      quantity: parseInt(quantity),
    };

    // Add selling plan if provided (subscription only)
    if (sellingPlanId) {
      mainItem.selling_plan = sellingPlanId;
    }

    const items = [mainItem];

    // Add gift variants if they exist
    if (giftVariantIds) {
      const giftIds = giftVariantIds.split(',').filter((id) => id.trim());
      giftIds.forEach((giftId) => {
        items.push({
          id: giftId.trim(),
          quantity: 1,
        });
      });
    }

    // Prepare order attributes
    const attributes = {
      'Full-Price-Offer': offerVersion || '',
      'offer-discount': discountPercent || '',
      dog1_weight: variantTitle,
    };

    // Add items to cart with attributes
    const success = await this.addToCart(items, attributes);

    if (success) {
      // Apply discount code if exists and redirect to checkout
      if (giftCode && giftCode.trim()) {
        window.location.href = `/checkout?discount=${giftCode}`;
      } else {
        window.location.href = '/checkout';
      }
    } else {
      // Re-enable button and hide loading state
      button.disabled = false;
      if (spinner) spinner.classList.add('hidden');
      if (hideButtonText && buttonText) buttonText.classList.remove('hidden');
      this.updatePrices();
      alert('There was an error adding items to cart. Please try again.');
    }
  }

  /**
   * Determine checkout parameters based on variant mode and subscription state
   * - has_sub_only: Always use subscription variant ID and add selling plan
   * - has_onetime_only: Always use one-time variant ID, no selling plan
   * - has_both: Use subscription or one-time variant ID based on toggle
   * - has_none: Use dogsize variant, subscription based on toggle
   */
  async handleCheckout() {
    // Prevent concurrent submissions (double-click protection)
    if (this.submitButton) {
      if (this.submitButton.disabled) return;
      this.submitButton.disabled = true;
    }

    try {
      const activeInput = this.getActiveInput();
      if (!activeInput) {
        if (this.submitButton) this.submitButton.disabled = false;
        return;
      }

      const variantMode = activeInput.dataset.variantMode || 'has_none';
      const overrideSubVariantId = activeInput.dataset.overrideSubVariantId;
      const overrideOnetimeVariantId = activeInput.dataset.overrideOnetimeVariantId;

      // Determine subscription state based on variant mode and toggle
      let isSubscription;
      let variantIdToUse = null;

      if (variantMode === 'has_sub_only') {
        // Always subscription, use override variant ID
        isSubscription = true;
        variantIdToUse = overrideSubVariantId;
      } else if (variantMode === 'has_onetime_only') {
        // Always one-time, use override variant ID, no selling plan
        isSubscription = false;
        variantIdToUse = overrideOnetimeVariantId;
      } else if (variantMode === 'has_both') {
        // Use toggle state, select appropriate override variant ID
        isSubscription = this.subscriptionToggle ? this.subscriptionToggle.checked : true;
        variantIdToUse = isSubscription ? overrideSubVariantId : overrideOnetimeVariantId;
      } else {
        // has_none: use toggle state, dogsize variant (variantIdToUse stays null)
        isSubscription = this.subscriptionToggle ? this.subscriptionToggle.checked : true;
      }

      const checkoutOptions = {
        button: this.submitButton,
        variantIdToUse: variantIdToUse,
        discountPercent: isSubscription
          ? activeInput.dataset.subDiscountPercent
          : activeInput.dataset.onetimeDiscountPercent,
        hideButtonText: true,
      };

      // Add selling plan only if subscription
      if (isSubscription) {
        checkoutOptions.sellingPlanId = activeInput.dataset.sellingPlanId;
      }

      await this.processCheckout(checkoutOptions);
    } catch (error) {
      console.error('Error in handleCheckout:', error);
      if (this.submitButton) {
        this.submitButton.disabled = false;
        const spinner = this.submitButton.querySelector('.loading__spinner');
        const buttonText = this.submitButton.querySelector('.picker-submit_btn-text');
        if (spinner) spinner.classList.add('hidden');
        if (buttonText) buttonText.classList.remove('hidden');
      }
      alert('There was an error adding items to cart. Please try again.');
    }
  }
}

customElements.define('main-offer-wu-18233', MainOfferWu18233);

// Store timer instance globally for cleanup
let deliveryTimerInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  deliveryTimerInstance = new DeliveryTimer();
});

// Clean up timer on page unload to prevent memory leaks
window.addEventListener('beforeunload', () => {
  if (deliveryTimerInstance) {
    deliveryTimerInstance.cleanup();
    deliveryTimerInstance = null;
  }
});

// Handle back/forward cache restoration (when user navigates back from checkout)
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    // Page was restored from bfcache, reset button
    const offerElement = document.querySelector('main-offer-wu-18233');
    if (offerElement && offerElement.resetButton) {
      offerElement.resetButton();
    }
  }
});

class DogSizeSelector extends HTMLElement {
  static initialized = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Cache DOM references - only for buttons in this instance
    this.buttons = this.querySelectorAll('.dog-size-selector__button');
    this.offerElement = document.querySelector('main-offer-wu-18233');

    // Restore saved dog size if exists (only run once for first instance)
    if (!DogSizeSelector.initialized) {
      this.restoreDogSize();
      DogSizeSelector.initialized = true;
    }

    // Setup event listeners
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Handle button clicks
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleDogSizeChange(button);
      });
    });
  }

  handleDogSizeChange(button) {
    const dogSize = button.dataset.size;
    const dogsizeIndex = button.dataset.dogsizeIndex;

    // Update active button state for ALL dog size selectors (main content and popup)
    const allButtons = document.querySelectorAll('.dog-size-selector__button');
    allButtons.forEach((btn) => {
      if (btn.dataset.size === dogSize) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Save to sessionStorage
    sessionStorage.setItem('main-offer-wu-18233-dogsize', dogSize);
    sessionStorage.setItem('main-offer-wu-18233-dogsize-index', dogsizeIndex);

    // Update URL weight parameter
    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set('weight', dogSize);
    window.history.replaceState({}, '', currentURL.toString());

    // Switch carousel based on dog size
    this.switchCarousel(dogSize);

    // Filter offer quantities based on dog size index
    this.filterOffersByDogSize(dogsizeIndex);

    // Update all picker data
    this.updatePickerData(button);
  }

  filterOffersByDogSize(dogsizeIndex) {
    const offerWrappers = document.querySelectorAll('.offer-quantity-wrapper, .offer-onetime-cta-wrapper');

    // Convert dogsizeIndex to string for comparison
    const dogsizeIndexStr = String(dogsizeIndex);

    // Step 1: Get the currently selected offer's position within its dogsize group
    let currentSelectedPositionIndex = this.getSelectedOfferPositionIndex();

    // Step 2: Collect visible offers for the NEW dogsize (before applying visibility)
    const newDogsizeOffers = [];

    offerWrappers.forEach((wrapper) => {
      const offerDogsizeIndex = wrapper.dataset.offerDogsize;
      const isAlwaysVisible = wrapper.hasAttribute('data-offer-always-visible');
      const isHiddenByVariantMode = wrapper.classList.contains('offer-quantity-wrapper--hidden-variant-mode');

      // Check if this offer belongs to the new dogsize
      const belongsToNewDogsize = isAlwaysVisible || offerDogsizeIndex === '0' || offerDogsizeIndex === dogsizeIndexStr;

      if (belongsToNewDogsize) {
        wrapper.classList.remove('offer-quantity-wrapper--hidden');
        wrapper.classList.remove('offer-quantity-wrapper--hidden-dogsize');
        // Only consider visible if not hidden by variant mode
        if (!isHiddenByVariantMode) {
          wrapper.style.display = '';
          newDogsizeOffers.push(wrapper);
        }
      } else {
        wrapper.classList.add('offer-quantity-wrapper--hidden');
        wrapper.classList.add('offer-quantity-wrapper--hidden-dogsize');
        wrapper.style.display = 'none';
        // Uncheck hidden offers
        const input = wrapper.querySelector('input[type="radio"]');
        if (input) {
          input.checked = false;
        }
      }
    });

    // Step 3: Select the offer at the same position index, or fall back
    if (newDogsizeOffers.length > 0) {
      // If no previous selection, use position 0
      if (currentSelectedPositionIndex === -1) {
        currentSelectedPositionIndex = 0;
      }

      // Clamp the position index to available offers (fall back to last if position doesn't exist)
      const targetPositionIndex = Math.min(currentSelectedPositionIndex, newDogsizeOffers.length - 1);
      const offerToSelect = newDogsizeOffers[targetPositionIndex];

      if (offerToSelect) {
        const input = offerToSelect.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // After dogsize filtering, also update visibility by variant mode
    const offerElement = document.querySelector('main-offer-wu-18233');
    if (offerElement && offerElement.updateOfferVisibilityByVariantMode) {
      offerElement.updateOfferVisibilityByVariantMode();
    }
  }

  getSelectedOfferPositionIndex() {
    const offerWrappers = document.querySelectorAll('.offer-quantity-wrapper');
    let positionIndex = 0;
    let selectedPositionIndex = -1;

    offerWrappers.forEach((wrapper) => {
      // Only count visible offers (not hidden by dogsize or variant mode)
      const isHiddenByDogsize =
        wrapper.classList.contains('offer-quantity-wrapper--hidden') ||
        wrapper.classList.contains('offer-quantity-wrapper--hidden-dogsize');
      const isHiddenByVariantMode = wrapper.classList.contains('offer-quantity-wrapper--hidden-variant-mode');

      if (!isHiddenByDogsize && !isHiddenByVariantMode) {
        const input = wrapper.querySelector('input[type="radio"]');
        if (input && input.checked) {
          selectedPositionIndex = positionIndex;
        }
        positionIndex++;
      }
    });

    return selectedPositionIndex;
  }

  switchCarousel(dogSize) {
    // Find carousels with dog size filtering (uses data-dogsize attribute)
    const dogsizeCarousels = document.querySelectorAll('.offer-content__left [data-dogsize]');

    if (dogsizeCarousels.length > 0 && dogSize) {
      // Use dogsize-specific carousel switching
      let activeCarousel = null;

      dogsizeCarousels.forEach((carousel) => {
        if (carousel.dataset.dogsize === dogSize) {
          carousel.classList.remove('hidden');
          activeCarousel = carousel;
        } else {
          carousel.classList.add('hidden');
        }
      });

      // Force carousel to recalculate dimensions
      if (activeCarousel) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          const carouselElement = activeCarousel.querySelector('carousel-container');
          if (carouselElement && typeof carouselElement.init === 'function') {
            carouselElement.init();
          }
        }, 50);
      }
      return;
    }

    // Fall back to old sb/lb carousel switching (for backward compatibility)
    const sbCarousel = document.querySelector('.offer-content__left .offer-carousel-sb');
    const lbCarousel = document.querySelector('.offer-content__left .offer-carousel-lb');

    // Return if carousels don't exist
    if (!sbCarousel || !lbCarousel) return;

    // Determine carousel type based on dog size (small/large dog grouping)
    const isSmallDog = dogSize === '0-35lbs' || dogSize === '36-65lbs';

    if (isSmallDog) {
      sbCarousel.classList.remove('hidden');
      lbCarousel.classList.add('hidden');
    } else {
      sbCarousel.classList.add('hidden');
      lbCarousel.classList.remove('hidden');
    }

    // Force carousel to recalculate dimensions
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));

      // Reinitialize active carousel
      const activeCarousel = isSmallDog ? sbCarousel : lbCarousel;
      const carouselElement = activeCarousel.querySelector('carousel-container');
      if (carouselElement && typeof carouselElement.init === 'function') {
        carouselElement.init();
      }
    }, 50);
  }

  updatePickerData(button) {
    // Get variant info from the button (for updating variant-specific data)
    const variantId = button.dataset.variantId;
    const variantTitle = button.dataset.variantTitle;
    const variantPrice = parseInt(button.dataset.variantPrice) || 0;
    const dogsizeIndex = button.dataset.dogsizeIndex;

    // Check if subscription is enabled
    const subscriptionToggle = document.querySelector('#subscription-toggle');
    const isSubscription = subscriptionToggle && subscriptionToggle.checked;

    // Get offer_version from parent element
    const offerElement = document.querySelector('main-offer-wu-18233');
    const offerVersion = offerElement ? offerElement.dataset.offerVersion || '' : '';

    // Get all visible quantity inputs (only update visible offers)
    const offerWrappers = document.querySelectorAll('.offer-quantity-wrapper:not(.offer-quantity-wrapper--hidden)');

    offerWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('input[name="offer-quantity"]');
      if (!input) return;

      // Update variant-specific data attributes (these change when dogsize changes)
      if (variantId) {
        input.dataset.variantId = variantId;
      }
      if (variantTitle) {
        input.dataset.variantTitle = variantTitle.replaceAll(' ', '');
      }
      if (offerVersion) {
        input.dataset.offerVersion = offerVersion;
      }

      // Get quantity and discount percentages from the input
      const quantity = parseInt(input.dataset.quantity) || 1;
      const subDiscountPercent = parseFloat(input.dataset.subDiscountPercent) || 0;
      const onetimeDiscountPercent = parseFloat(input.dataset.onetimeDiscountPercent) || 0;
      const intervalDays = input.dataset.intervalDays;

      // Recalculate prices based on the new variant price
      if (variantPrice > 0) {
        // Get gift prices total (in cents) to include in strikethrough price
        const giftPricesTotal = parseInt(input.dataset.giftPricesTotal) || 0;

        // Calculate default price (variant price * quantity + gift prices)
        const defaultPrice = variantPrice * quantity + giftPricesTotal;

        // Calculate subscription discounted price
        const subDiscountDollars = Math.floor((variantPrice * subDiscountPercent) / 100);
        const subDiscountedPrice = (variantPrice - subDiscountDollars) * quantity;

        // Calculate one-time discounted price
        const otpDiscountDollars = Math.floor((variantPrice * onetimeDiscountPercent) / 100);
        const otpDiscountedPrice = (variantPrice - otpDiscountDollars) * quantity;

        // Update input data attributes with recalculated prices
        input.dataset.priceDefault = this.formatMoney(defaultPrice);
        input.dataset.subPriceDiscounted = this.formatMoney(subDiscountedPrice);
        input.dataset.onetimePriceDiscounted = this.formatMoney(otpDiscountedPrice);
      }

      // Update visual display on the label based on subscription state and variant mode
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        // Get the updated prices from the input's data attributes
        const subPriceDiscounted = input.dataset.subPriceDiscounted;
        const onetimePriceDiscounted = input.dataset.onetimePriceDiscounted;
        const variantMode = input.dataset.variantMode || 'has_none';
        const includeGiftsPrices = input.dataset.includeGiftsPrices === 'true';
        const defaultPriceValue = input.dataset.priceDefault;

        // Determine which discount/price to show based on variant mode
        let discountToShow, priceToShow;
        if (variantMode === 'has_sub_only') {
          discountToShow = subDiscountPercent;
          priceToShow = subPriceDiscounted;
        } else if (variantMode === 'has_onetime_only') {
          discountToShow = onetimeDiscountPercent;
          priceToShow = onetimePriceDiscounted;
        } else {
          discountToShow = isSubscription ? subDiscountPercent : onetimeDiscountPercent;
          priceToShow = isSubscription ? subPriceDiscounted : onetimePriceDiscounted;
        }

        // Recalculate discount percentage when gift prices are included
        if (includeGiftsPrices && defaultPriceValue && priceToShow) {
          const defaultPriceCents = parseFloat(defaultPriceValue.replace(/[^0-9.]/g, '')) * 100;
          const discountedPriceCents = parseFloat(priceToShow.replace(/[^0-9.]/g, '')) * 100;
          if (defaultPriceCents > 0) {
            discountToShow = parseFloat(((defaultPriceCents - discountedPriceCents) / defaultPriceCents * 100).toFixed(1));
          }
        }

        // Update discount badge
        const badgeWrapper = label.querySelector('.offer-block__center');
        const discountBadge = label.querySelector('.offer-block__badge-relative');
        if (discountBadge) {
          if (discountToShow && discountToShow > 0) {
            discountBadge.textContent = `Save ${discountToShow}%`;
            if (badgeWrapper) {
              badgeWrapper.style.display = '';
            }
          } else {
            if (badgeWrapper) {
              badgeWrapper.style.display = 'none';
            }
          }
        }

        // Calculate and update price per day
        const pricePerDay = label.querySelector('.offer-block__price-per-day');
        if (pricePerDay && intervalDays) {
          const pricePerDayValue = this.calculatePricePerDay(priceToShow, intervalDays);
          pricePerDay.textContent = `${pricePerDayValue}/day`;
        }

        // Update custom titles only for has_both or has_none modes
        // has_sub_only and has_onetime_only have static content set by Liquid
        if (variantMode !== 'has_sub_only' && variantMode !== 'has_onetime_only') {
          const titleSub = label.querySelector('.offer-block__title-subscription');
          const titleOnetime = label.querySelector('.offer-block__title-onetime');
          const titleDefault = label.querySelector('.offer-block__title-default');
          const secondarySub = label.querySelector('.offer-block__bottom-subscription-text');
          const secondaryOnetime = label.querySelector('.offer-block__bottom-onetime-text');

          if (titleSub && titleOnetime) {
            titleSub.style.display = isSubscription ? 'block' : 'none';
            titleOnetime.style.display = isSubscription ? 'none' : 'block';
            if (titleDefault) {
              titleDefault.style.display = 'none';
            }
          } else if (titleSub) {
            titleSub.style.display = isSubscription ? 'block' : 'none';
            if (titleDefault) {
              titleDefault.style.display = isSubscription ? 'none' : 'inline';
            }
          } else if (titleOnetime) {
            titleOnetime.style.display = isSubscription ? 'none' : 'block';
            if (titleDefault) {
              titleDefault.style.display = isSubscription ? 'inline' : 'none';
            }
          } else if (titleDefault) {
            titleDefault.style.display = 'inline';
          }

          // Update secondary text
          if (secondarySub) {
            secondarySub.style.display = isSubscription ? '' : 'none';
          }
          if (secondaryOnetime) {
            secondaryOnetime.style.display = isSubscription ? 'none' : '';
          }
        }
      }
    });

    // Trigger price update on the main offer element
    if (this.offerElement && this.offerElement.updatePrices) {
      this.offerElement.updatePrices();
    }
  }

  calculatePricePerDay(priceString, intervalDays) {
    // Remove $ and any other non-numeric characters except decimal point
    const priceValue = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    const days = parseInt(intervalDays);

    if (isNaN(priceValue) || isNaN(days) || days === 0) {
      return '$0.00';
    }

    const perDay = priceValue / days;
    return `$${perDay.toFixed(2)}`;
  }

  formatMoney(cents) {
    // Validate input
    if (cents === undefined || cents === null || cents === '') {
      console.warn('formatMoney: Invalid cents value provided:', cents);
      return '$0.00';
    }

    // Convert cents to dollars and format
    const parsedCents = parseInt(cents);

    // Check if parsing resulted in NaN
    if (isNaN(parsedCents)) {
      console.warn('formatMoney: Could not parse cents value:', cents);
      return '$0.00';
    }

    const dollars = parsedCents / 100;
    return `$${dollars.toFixed(2)}`;
  }

  restoreDogSize() {
    const savedDogSize = sessionStorage.getItem('main-offer-wu-18233-dogsize');
    if (savedDogSize) {
      const savedButton = Array.from(this.buttons).find((btn) => btn.dataset.size === savedDogSize);
      if (savedButton && !savedButton.classList.contains('active')) {
        // Update to saved dog size
        this.handleDogSizeChange(savedButton);
      } else if (savedButton) {
        // Button is already active, switch carousel and filter offers
        const dogSize = savedButton.dataset.size;
        const dogsizeIndex = savedButton.dataset.dogsizeIndex;
        this.switchCarousel(dogSize);
        this.filterOffersByDogSize(dogsizeIndex);
        // Update picker data to sync variant IDs and prices with the active dog size
        this.updatePickerData(savedButton);
      }
    } else {
      // No saved dog size, use the initially active button (set by default_offer_index)
      const activeButton = this.querySelector('.dog-size-selector__button.active');
      if (activeButton) {
        // Switch carousel and filter offers for the default active button
        const dogSize = activeButton.dataset.size;
        const dogsizeIndex = activeButton.dataset.dogsizeIndex;
        this.switchCarousel(dogSize);
        this.filterOffersByDogSize(dogsizeIndex);
        // Update picker data to sync variant IDs and prices with the active dog size
        this.updatePickerData(activeButton);
      }
    }
  }
}

customElements.define('dog-size-selector', DogSizeSelector);

// One-Time CTA Button Handler
class OnetimeCtaHandler {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const ctaButton = e.target.closest('.offer-onetime-cta');
      if (ctaButton) {
        e.preventDefault();
        this.handleOnetimePurchase(ctaButton);
      }
    });

    // Reset button state when navigating back from checkout (bfcache)
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        this.resetAllButtons();
      }
    });
  }

  resetAllButtons() {
    const buttons = document.querySelectorAll('.offer-onetime-cta');
    buttons.forEach((button) => {
      const originalText = button.dataset.originalText;
      if (originalText) {
        button.textContent = originalText;
        button.disabled = false;
      }
    });
  }

  async handleOnetimePurchase(button) {
    // Prevent double-click
    if (button.disabled) return;
    button.disabled = true;

    const variantId = button.dataset.onetimeVariantId;
    const quantity = parseInt(button.dataset.quantity) || 1;
    const variantTitle = button.dataset.variantTitle || '';
    const discountPercent = button.dataset.discountPercent || '0';

    // Get offer version from the nearest main-offer element
    const mainOffer = button.closest('main-offer-wu-18233');
    const offerVersion = mainOffer ? mainOffer.dataset.offerVersion || '' : '';

    if (!variantId) {
      console.error('One-time CTA: No variant ID provided');
      button.disabled = false;
      return;
    }

    // Store original text and show loading state
    button.dataset.originalText = button.textContent;
    button.textContent = 'Loading...';

    try {
      // Clear cart
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      // Prepare cart attributes for analytics tracking
      const attributes = {
        'Full-Price-Offer': offerVersion,
        'offer-discount': discountPercent,
        dog1_weight: variantTitle,
      };

      // Add item to cart with attributes
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
          attributes: attributes,
        }),
      });

      if (response.ok) {
        window.location.href = '/checkout';
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('One-time CTA error:', error);
      button.textContent = button.dataset.originalText;
      button.disabled = false;
      alert('There was an error. Please try again.');
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new OnetimeCtaHandler();
});
